(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout;
  const e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  let t = [], n = false, a = null;
  const o = (e2) => Date.now() - e2 > 3e5, i = async ({ shopDomain: e2, accessToken: r2, query: t2, variables: n2 }) => {
    try {
      const a2 = `https://${e2}/api/2024-07/graphql.json`, o2 = { "X-Shopify-Storefront-Access-Token": r2, "Content-Type": "application/json" }, i2 = await fetch(a2, { method: "POST", headers: o2, body: JSON.stringify({ query: t2, variables: n2 }) });
      return await i2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, c = async (i2, c2, l2, u2, p2, d2) => {
    const y2 = ((e2, r2, t2, n2, a2) => `${e2}:${r2}:${t2}:${JSON.stringify(n2)}:${a2}`)(i2, l2, u2, p2, d2), m2 = e.get(y2);
    if (m2 && !o(m2.timestamp)) return m2.data;
    const f2 = r.get(y2);
    if (f2) return f2;
    const g2 = (P2 = { shopDomain: i2, accessToken: c2, handle: l2, customerGroupId: u2, customerTags: p2, clayCountryIsoCode: d2, cacheKey: y2 }, new Promise((e2, r2) => {
      t.push({ ...P2, resolve: e2, reject: r2 }), n || (n = true, queueMicrotask(() => {
        n = false, function() {
          if (0 === t.length) return;
          const e3 = t;
          t = [];
          for (let r3 = 0; r3 < e3.length; r3 += 10) {
            const t2 = e3.slice(r3, r3 + 10), n2 = null === a, o2 = s(t2, n2);
            n2 && (a = o2);
          }
        }();
      }));
    }));
    var P2;
    return r.set(y2, g2), g2.finally(() => {
      r.delete(y2);
    }), g2;
  };
  async function s(r2, t2) {
    var _a, _b, _c;
    if (!t2 && a) try {
      await a;
    } catch {
    }
    const n2 = r2[0];
    try {
      const t3 = `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${r2.map((e2) => e2.handle).map((e2, r3) => `p${r3}: product(handle: ${JSON.stringify(e2)}) {
      title
      handle
      variants(first: 50) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n")}
  }`, a2 = await i({ shopDomain: n2.shopDomain, accessToken: n2.accessToken, query: t3, variables: { country: n2.clayCountryIsoCode } });
      if (!(a2 == null ? void 0 : a2.data)) {
        const e2 = new Error("Empty response from Storefront API");
        return void r2.forEach((r3) => r3.reject(e2));
      }
      for (let t4 = 0; t4 < r2.length; t4++) {
        const n3 = r2[t4], o2 = a2.data[`p${t4}`];
        if (!o2) {
          const r3 = { handle: n3.handle, allVariants: [] };
          e.set(n3.cacheKey, { data: r3, timestamp: Date.now() }), n3.resolve(r3);
          continue;
        }
        if ((_b = (_a = o2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          u(n3.shopDomain, n3.accessToken, n3.handle, n3.customerGroupId, n3.customerTags, n3.clayCountryIsoCode, n3.cacheKey).then((e2) => n3.resolve(e2)).catch(n3.reject);
          continue;
        }
        const i2 = (((_c = o2.variants) == null ? void 0 : _c.edges) || []).map((e2) => l(e2.node, n3.customerGroupId, n3.customerTags)), c2 = { handle: n3.handle, allVariants: i2 };
        e.set(n3.cacheKey, { data: c2, timestamp: Date.now() }), n3.resolve(c2);
      }
      p();
    } catch (e2) {
      console.error("Error in batched product metafield fetch:", e2), r2.forEach((r3) => r3.reject(e2));
    }
  }
  function l(e2, r2, t2) {
    var _a;
    const n2 = e2.id.split("/").pop(), a2 = (_a = e2.metafield) == null ? void 0 : _a.value, o2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const r3 = e3[0];
      if ("customerGroupId" in r3) return t3 = e3, Array.isArray(t3) ? t3.map((e4 = {}) => {
        const { customerGroupId: r4 = "", customerTag: t4 = "", type: n3 = "WHOLESALE", wholesalePrice: a3 = null, quantityPrice: o3 = {} } = e4;
        let i3 = false;
        "QUANTITY" === n3 && (i3 = !!o3.isVariantUnique);
        let c3 = [];
        return "WHOLESALE" === n3 && null != a3 ? c3.push({ quantity: "1", price: a3 }) : Array.isArray(o3.value) && (c3 = o3.value), { ownerId: "", customerGroupId: r4, customerTag: t4, markets: [{ handle: "", currency: "", pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: i3, priceSource: "R", values: c3 } }] };
      }) : [];
      var t3;
      if ("i" in r3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const r4 = e4.map((e5 = {}) => {
          let r5 = e5.o || "", [t4 = "", n3 = ""] = (e5.i || "").split("~"), a3 = e5.p.split("|").map((e6) => {
            let [r6 = "", t5 = "", n4 = "A", a4 = "0", o3 = "R", i3 = ""] = e6.split("~"), c3 = i3.split(";").map((e7) => {
              let [r7 = "1", t6 = "0"] = e7.split(":");
              return { quantity: r7, price: t6 };
            }) ?? [];
            return { handle: r6, currency: t5, pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n4, priceSource: o3, isVariantUnique: "1" === a4, values: c3 } };
          });
          return { ownerId: r5, customerGroupId: t4, customerTag: n3, markets: a3 };
        });
        return r4;
      }(e3);
      return [];
    }("string" == typeof a2 ? JSON.parse(a2) : []);
    let i2 = o2.find((e3) => e3.customerGroupId === r2 && !["LOGGED_IN", "ALL"].includes(r2) || t2.includes(e3.customerTag));
    i2 || "ALL" === r2 || (i2 = o2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), i2 || (i2 = o2.find((e3) => "ALL" === e3.customerGroupId));
    const c2 = window.clayMarketHandle;
    if (i2) {
      const r3 = i2.markets.find((e3) => e3.handle === c2 || "" === e3.handle) || null;
      if (r3) {
        const t3 = { ...i2, markets: [r3] };
        if ("" === t3.ownerId || t3.ownerId === n2.split("/").pop()) return { id: n2, title: e2.title, pricingRule: t3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: n2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function u(r2, t2, n2, a2, o2, c2, s2) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    try {
      let u2, d2 = true;
      const y2 = [];
      for (; d2; ) {
        const p2 = await i({ shopDomain: r2, accessToken: t2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${u2 ? `"${u2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: n2, country: c2 } });
        if (!((_a = p2.data) == null ? void 0 : _a.product)) {
          const r3 = { handle: n2, allVariants: [] };
          return e.set(s2, { data: r3, timestamp: Date.now() }), r3;
        }
        const m3 = (((_b = p2.data.product.variants) == null ? void 0 : _b.edges) || []).map((e2) => l(e2.node, a2, o2));
        y2.push(...m3), d2 = (_f = (_e = (_d = (_c = p2.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e.pageInfo) == null ? void 0 : _f.hasNextPage, u2 = (_j = (_i = (_h = (_g = p2.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const m2 = { handle: n2, allVariants: y2 };
      return e.set(s2, { data: m2, timestamp: Date.now() }), p(), m2;
    } catch (e2) {
      throw console.error("Error fetching product metafield:", e2), e2;
    }
  }
  const p = () => {
    for (const [r2, t2] of e.entries()) o(t2.timestamp) && e.delete(r2);
  };
  function d(e2, r2) {
    if (null === e2) return "";
    const t2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = t2.toFixed(2), a2 = t2.toFixed(0), o2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), i2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = n2.replace(".", ","), u2 = o2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), p2 = c2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return r2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", a2).replace("{{amount_with_comma_separator}}", o2).replace("{{amount_no_decimals_with_comma_separator}}", i2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", s2).replace("{{amount_with_comma_decimal}}", l2).replace("{{amount_with_comma_separator_and_comma_decimal}}", u2).replace("{{amount_with_period_separator_and_comma_decimal}}", p2);
  }
  function y(e2, r2, t2) {
    var _a;
    let n2 = "", a2 = "", o2 = "", i2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let s2 = c2.pricing.type;
    return "QUANTITY" === s2 ? { retailPriceText: n2, compareAtPriceText: a2, savingsText: o2, maxRetailPriceText: i2 } = function(e3, r3, t3, n3) {
      let a3 = n3.pricing.strategy, o3 = n3.pricing.values, i3 = n3.currency, c3 = e3.price.currencyCode, s3 = "R" === n3.pricing.priceSource ? e3.price.amount : "C" === n3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!s3 || "" === s3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let u2 = o3.filter((e4) => Number(e4.quantity) <= t3).reduce((e4, r4) => Number(r4.quantity) > Number(e4.quantity) ? r4 : e4, { price: "0", quantity: "0" }).price;
      if (i3 !== c3 && "" !== i3) {
        if (!l2 || !l2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(a3) && (u2 = (parseFloat(u2) * l2.conversion_rate).toFixed(2).toString());
      }
      let p2 = "A" === a3 ? u2 : "P" === a3 ? (parseFloat(s3) * (1 - parseFloat(u2) / 100)).toFixed(2).toString() : "F" === a3 ? (parseFloat(s3) - parseFloat(u2)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && l2 && l2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p2) < 0 || parseFloat(p2) > parseFloat(e3.price.amount)) && (p2 = e3.price.amount);
      let y2 = d(p2, clayProductPriceConfig.priceDisplayText), m2 = d(s3, clayProductPriceConfig.compareAtPriceDisplayText), f2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(s3) - parseFloat(p2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(s3) - parseFloat(p2)) / parseFloat(s3) * 100).toFixed(2) : 0, g2 = d(f2, clayProductPriceConfig.savingsDisplayText);
      return l2 && (y2 = window.clayCurrencySymbol + parseFloat(p2).toFixed(2) + " " + window.clayCountryCurrency, m2 = window.clayCurrencySymbol + parseFloat(s3).toFixed(2) + " " + window.clayCountryCurrency, g2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + f2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? f2 + "%" : "")), { retailPriceText: y2, compareAtPriceText: m2, savingsText: g2, maxRetailPriceText: "" };
    }(e2, 0, t2, c2) : "WHOLESALE" === s2 && ({ retailPriceText: n2, compareAtPriceText: a2, savingsText: o2, maxRetailPriceText: i2 } = function(e3, r3, t3) {
      let n3 = t3.pricing.strategy;
      t3.pricing.values;
      let a3 = t3.currency, o3 = e3.price.currencyCode, i3 = window.marketConversionRate, c3 = "R" === t3.pricing.priceSource ? e3.price.amount : "C" === t3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s3 = t3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (a3 !== o3 && "" !== a3) {
        if (!i3 || !i3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (s3 = (parseFloat(s3) * i3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === n3 ? s3 : "P" === n3 ? (parseFloat(c3) * (1 - parseFloat(s3) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c3) - parseFloat(s3)).toFixed(2).toString() : e3.price.amount;
      if ("" === a3 && i3 && i3.base_currency !== o3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let u2 = d(l2, clayProductPriceConfig.priceDisplayText), p2 = d(c3, clayProductPriceConfig.compareAtPriceDisplayText), y2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(l2)) / parseFloat(c3) * 100).toFixed(2) : 0, m2 = d(y2, clayProductPriceConfig.savingsDisplayText);
      return i3 && (u2 = window.clayCurrencySymbol + parseFloat(l2).toFixed(2) + " " + window.clayCountryCurrency, p2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, m2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + y2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? y2 + "%" : "")), { retailPriceText: u2, compareAtPriceText: p2, savingsText: m2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: n2, compareAtPriceText: a2, savingsText: o2, maxRetailPriceText: i2 };
  }
  function m(e2, r2) {
    var _a;
    let t2 = "", n2 = "", a2 = "", o2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!o2) return { retailPrice: "", compareAtPrice: "", savings: "" };
    let i2 = o2.pricing.type;
    return "QUANTITY" === i2 ? { retailPrice: t2, compareAtPrice: n2, savings: a2 } = function(e3, r3, t3) {
      let n3 = t3.pricing.strategy, a3 = t3.pricing.values, o3 = t3.currency, i3 = e3.price.currencyCode, c2 = "R" === t3.pricing.priceSource ? e3.price.amount : "C" === t3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s2 = window.marketConversionRate;
      if (!c2 || "" === c2) return { retailPrice: "", compareAtPrice: "", savings: "" };
      let l2 = a3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, r4) => Number(r4.quantity) > Number(e4.quantity) ? r4 : e4, { price: "0", quantity: "0" }).price;
      if (o3 !== i3 && "" !== o3) {
        if (!s2 || !s2.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(n3) && (l2 = (parseFloat(l2) * s2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? l2 : "P" === n3 ? (parseFloat(c2) * (1 - parseFloat(l2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c2) - parseFloat(l2)).toFixed(2).toString() : e3.price.amount;
      if ("" === o3 && s2 && s2.base_currency !== i3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let p2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c2) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c2) - parseFloat(u2)) / parseFloat(c2) * 100).toFixed(0) : 0;
      return { retailPrice: u2, compareAtPrice: parseFloat(c2).toFixed(2), savings: p2 };
    }(e2, r2, o2) : "WHOLESALE" === i2 && ({ retailPrice: t2, compareAtPrice: n2, savings: a2 } = function(e3, r3) {
      let t3 = r3.pricing.strategy;
      r3.pricing.values;
      let n3 = r3.currency, a3 = e3.price.currencyCode, o3 = window.marketConversionRate, i3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, c2 = r3.pricing.values[0].price;
      if (!i3 || "" === i3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      if (n3 !== a3 && "" !== n3) {
        if (!o3 || !o3.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(t3) && (c2 = (parseFloat(c2) * o3.conversion_rate).toFixed(2).toString());
      }
      let s2 = "A" === t3 ? c2 : "P" === t3 ? (parseFloat(i3) * (1 - parseFloat(c2) / 100)).toFixed(2).toString() : "F" === t3 ? (parseFloat(i3) - parseFloat(c2)).toFixed(2).toString() : e3.price.amount;
      if ("" === n3 && o3 && o3.base_currency !== a3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(s2) < 0 || parseFloat(s2) > parseFloat(e3.price.amount)) && (s2 = e3.price.amount);
      let l2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(i3) - parseFloat(s2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(i3) - parseFloat(s2)) / parseFloat(i3) * 100).toFixed(2) : 0;
      return { retailPrice: s2, compareAtPrice: parseFloat(i3).toFixed(2), savings: l2 };
    }(e2, o2)), { retailPrice: t2, compareAtPrice: n2, savings: a2 };
  }
  function f(e2) {
    if (!e2 || "" === e2) return null;
    let r2 = null;
    const t2 = e2.match(/\/products\/([^/?#]+)/);
    return t2 && t2[1] && (r2 = decodeURIComponent(t2[1])), r2;
  }
  const g = "%[a-f0-9]{2}", P = new RegExp("(" + g + ")|([^%]+?)", "gi"), h = new RegExp("(" + g + ")+", "gi");
  function F(e2, r2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    r2 = r2 || 1;
    const t2 = e2.slice(0, r2), n2 = e2.slice(r2);
    return Array.prototype.concat.call([], F(t2), F(n2));
  }
  function v(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let r2 = e2.match(P) || [];
      for (let t2 = 1; t2 < r2.length; t2++) r2 = (e2 = F(r2, t2).join("")).match(P) || [];
      return e2;
    }
  }
  function x(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const r2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let t2 = h.exec(e3);
        for (; t2; ) {
          try {
            r2[t2[0]] = decodeURIComponent(t2[0]);
          } catch {
            const e4 = v(t2[0]);
            e4 !== t2[0] && (r2[t2[0]] = e4);
          }
          t2 = h.exec(e3);
        }
        r2["%C2"] = "�";
        const n2 = Object.keys(r2);
        for (const t3 of n2) e3 = e3.replace(new RegExp(t3, "g"), r2[t3]);
        return e3;
      }(e2);
    }
  }
  function w(e2, r2) {
    const t2 = {};
    if (Array.isArray(r2)) for (const n2 of r2) {
      const r3 = Object.getOwnPropertyDescriptor(e2, n2);
      (r3 == null ? void 0 : r3.enumerable) && Object.defineProperty(t2, n2, r3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const a2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (a2.enumerable) {
        r2(n2, e2[n2], e2) && Object.defineProperty(t2, n2, a2);
      }
    }
    return t2;
  }
  function T(e2, r2) {
    if ("string" != typeof e2 || "string" != typeof r2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === r2) return [];
    const t2 = e2.indexOf(r2);
    return -1 === t2 ? [] : [e2.slice(0, t2), e2.slice(t2 + r2.length)];
  }
  const C = Symbol("encodeFragmentIdentifier");
  function S(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function b(e2, r2) {
    return r2.encode ? r2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function A(e2, r2) {
    return r2.decode ? x(e2) : e2;
  }
  function _(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? _(Object.keys(e2)).sort((e3, r2) => Number(e3) - Number(r2)).map((r2) => e2[r2]) : e2;
  }
  function k(e2) {
    const r2 = e2.indexOf("#");
    return -1 !== r2 && (e2 = e2.slice(0, r2)), e2;
  }
  function I(e2, r2, t2) {
    return "string" === t2 && "string" == typeof e2 ? e2 : "function" == typeof t2 && "string" == typeof e2 ? t2(e2) : !r2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== t2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? r2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function j(e2) {
    const r2 = (e2 = k(e2)).indexOf("?");
    return -1 === r2 ? "" : e2.slice(r2 + 1);
  }
  function R(e2, r2) {
    S((r2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...r2 }).arrayFormatSeparator);
    const t2 = function(e3) {
      let r3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, t3, n3) => {
            r3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), r3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][r3[1]] = t3) : n3[e4] = t3;
          };
        case "bracket":
          return (e4, t3, n3) => {
            r3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), r3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], t3] : n3[e4] = [t3] : n3[e4] = t3;
          };
        case "colon-list-separator":
          return (e4, t3, n3) => {
            r3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), r3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], t3] : n3[e4] = [t3] : n3[e4] = t3;
          };
        case "comma":
        case "separator":
          return (r4, t3, n3) => {
            const a2 = "string" == typeof t3 && t3.includes(e3.arrayFormatSeparator), o2 = "string" == typeof t3 && !a2 && A(t3, e3).includes(e3.arrayFormatSeparator);
            t3 = o2 ? A(t3, e3) : t3;
            const i2 = a2 || o2 ? t3.split(e3.arrayFormatSeparator).map((r5) => A(r5, e3)) : null === t3 ? t3 : A(t3, e3);
            n3[r4] = i2;
          };
        case "bracket-separator":
          return (r4, t3, n3) => {
            const a2 = /(\[])$/.test(r4);
            if (r4 = r4.replace(/\[]$/, ""), !a2) return void (n3[r4] = t3 ? A(t3, e3) : t3);
            const o2 = null === t3 ? [] : A(t3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[r4] ? n3[r4] = [...n3[r4], ...o2] : n3[r4] = o2;
          };
        default:
          return (e4, r4, t3) => {
            void 0 !== t3[e4] ? t3[e4] = [...[t3[e4]].flat(), r4] : t3[e4] = r4;
          };
      }
    }(r2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const a2 of e2.split("&")) {
      if ("" === a2) continue;
      const e3 = r2.decode ? a2.replaceAll("+", " ") : a2;
      let [o2, i2] = T(e3, "=");
      void 0 === o2 && (o2 = e3), i2 = void 0 === i2 ? null : ["comma", "separator", "bracket-separator"].includes(r2.arrayFormat) ? i2 : A(i2, r2), t2(A(o2, r2), i2, n2);
    }
    for (const [e3, t3] of Object.entries(n2)) if ("object" == typeof t3 && null !== t3 && "string" !== r2.types[e3]) for (const [n3, a2] of Object.entries(t3)) {
      const o2 = r2.types[e3] ? r2.types[e3].replace("[]", "") : void 0;
      t3[n3] = I(a2, r2, o2);
    }
    else "object" == typeof t3 && null !== t3 && "string" === r2.types[e3] ? n2[e3] = Object.values(t3).join(r2.arrayFormatSeparator) : n2[e3] = I(t3, r2, r2.types[e3]);
    return false === r2.sort ? n2 : (true === r2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(r2.sort)).reduce((e3, r3) => {
      const t3 = n2[r3];
      return e3[r3] = Boolean(t3) && "object" == typeof t3 && !Array.isArray(t3) ? _(t3) : t3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function N(e2, r2) {
    if (!e2) return "";
    S((r2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...r2 }).arrayFormatSeparator);
    const t2 = (t3) => r2.skipNull && null == e2[t3] || r2.skipEmptyString && "" === e2[t3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (r3) => (t3, n3) => {
            const a3 = t3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, [b(r3, e3), "[", a3, "]"].join("")] : [...t3, [b(r3, e3), "[", b(a3, e3), "]=", b(n3, e3)].join("")];
          };
        case "bracket":
          return (r3) => (t3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, [b(r3, e3), "[]"].join("")] : [...t3, [b(r3, e3), "[]=", b(n3, e3)].join("")];
        case "colon-list-separator":
          return (r3) => (t3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, [b(r3, e3), ":list="].join("")] : [...t3, [b(r3, e3), ":list=", b(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const r3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (t3) => (n3, a3) => void 0 === a3 || e3.skipNull && null === a3 || e3.skipEmptyString && "" === a3 ? n3 : (a3 = null === a3 ? "" : a3, 0 === n3.length ? [[b(t3, e3), r3, b(a3, e3)].join("")] : [[n3, b(a3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (r3) => (t3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, b(r3, e3)] : [...t3, [b(r3, e3), "=", b(n3, e3)].join("")];
      }
    }(r2), a2 = {};
    for (const [r3, n3] of Object.entries(e2)) t2(r3) || (a2[r3] = n3);
    const o2 = Object.keys(a2);
    return false !== r2.sort && o2.sort(r2.sort), o2.map((t3) => {
      const a3 = e2[t3];
      return void 0 === a3 ? "" : null === a3 ? b(t3, r2) : Array.isArray(a3) ? 0 === a3.length && "bracket-separator" === r2.arrayFormat ? b(t3, r2) + "[]" : a3.reduce(n2(t3), []).join("&") : b(t3, r2) + "=" + b(a3, r2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function E(e2, r2) {
    var _a;
    r2 = { decode: true, ...r2 };
    let [t2, n2] = T(e2, "#");
    return void 0 === t2 && (t2 = e2), { url: ((_a = t2 == null ? void 0 : t2.split("?")) == null ? void 0 : _a[0]) ?? "", query: R(j(e2), r2), ...r2 && r2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: A(n2, r2) } : {} };
  }
  function O(e2, r2) {
    r2 = { encode: true, strict: true, [C]: true, ...r2 };
    const t2 = k(e2.url).split("?")[0] || "";
    let n2 = N({ ...R(j(e2.url), { sort: false }), ...e2.query }, r2);
    n2 && (n2 = `?${n2}`);
    let a2 = function(e3) {
      let r3 = "";
      const t3 = e3.indexOf("#");
      return -1 !== t3 && (r3 = e3.slice(t3)), r3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(t2);
      n3.hash = e2.fragmentIdentifier, a2 = r2[C] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${t2}${n2}${a2}`;
  }
  function D(e2, r2, t2) {
    t2 = { parseFragmentIdentifier: true, [C]: false, ...t2 };
    const { url: n2, query: a2, fragmentIdentifier: o2 } = E(e2, t2);
    return O({ url: n2, query: w(a2, r2), fragmentIdentifier: o2 }, t2);
  }
  const q = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, r2, t2) {
    return D(e2, Array.isArray(r2) ? (e3) => !r2.includes(e3) : (e3, t3) => !r2(e3, t3), t2);
  }, extract: j, parse: R, parseUrl: E, pick: D, stringify: N, stringifyUrl: O }, Symbol.toStringTag, { value: "Module" })), L = window.clayStorefrontConfig || {}, U = window.clayCustomerTags || [];
  Shopify.theme;
  const G = window.clayMarketHandle, H = window.clayCountryCurrency, M = window.clayCountryIsoCode;
  async function V() {
    f(window.location.href) && async function() {
      console.log("processProductPage");
      let e2 = f(window.location.href);
      const r2 = await async function(e3) {
        const r3 = window.clayStorefrontConfig || {}, t3 = window.clayCustomerTier || {}, n3 = window.clayCustomerTags || [], a3 = window.clayCountryIsoCode, { allVariants: o3 } = await c(r3.shopDomain, r3.token, e3, "" === t3.customerGroupId ? "LOGGED_IN" : t3.customerGroupId, n3, a3);
        return o3;
      }(e2);
      console.log("allVariants", r2);
      const t2 = new URL(window.location.href);
      let n2 = q.parse(t2.search).variant;
      n2 || (n2 = r2[0].id);
      const a2 = r2.find((e3) => e3.id === n2);
      if (console.log("variant", a2), !a2.pricingRule) return;
      const o2 = document.querySelector(".main-product-price");
      if (console.log("priceBlock", o2), !o2) return;
      const i2 = document.querySelector(".add-to-cart-price");
      o2.getAttribute("data-variant-id") !== a2.id && o2.setAttribute("data-variant-id", "");
      let { retailPriceText: s2, compareAtPriceText: l2, savingsText: u2, maxRetailPriceText: p2 } = y(a2, 0, 1), { retailPrice: d2 } = m(a2, 1);
      if (!d2) return;
      const g2 = d2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (console.log("retailPriceText", s2), console.log("compareAtPriceText", l2), "" === s2) return;
      s2 !== l2 && "" !== l2 ? (o2.innerHTML = `<span>${s2}</span><span>(${l2})</span>`, i2.innerHTML = window.clayCurrencySymbol + g2) : (o2.innerHTML = `<span>${s2}</span>`, i2.innerHTML = window.clayCurrencySymbol + g2);
    }();
  }
  !async function() {
    await async function() {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { customer_tags: (U == null ? void 0 : U.join(",")) || "" } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
      let e2 = null;
      const r2 = await (async (e3, r3, t2) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let n2 = null, a2 = null, o2 = null, c2 = null;
        try {
          const s2 = await i({ shopDomain: e3, accessToken: r3, query: "query HighPricedProducts($country: CountryCode) @inContext(country: $country) {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }", variables: { country: t2 } });
          ((_c = (_b = (_a = s2 == null ? void 0 : s2.data) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.length) > 0 && (n2 = (_d = s2.data.products.edges[0].node.variants) == null ? void 0 : _d.edges[0].node.price);
          const l2 = await i({ shopDomain: e3, accessToken: r3, query: "query HighPricedProducts {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }" });
          if (((_g = (_f = (_e = l2 == null ? void 0 : l2.data) == null ? void 0 : _e.products) == null ? void 0 : _f.edges) == null ? void 0 : _g.length) > 0 && (a2 = (_h = l2.data.products.edges[0].node.variants) == null ? void 0 : _h.edges[0].node.price), n2 && a2) {
            const e4 = a2.currencyCode;
            e4 !== n2.currencyCode && (c2 = (parseFloat(n2.amount) / parseFloat(a2.amount)).toFixed(8), o2 = e4);
          }
          return { conversionRate: c2, baseCurrency: o2 };
        } catch (e4) {
          return console.error("Error fetching conversion rate:", e4), { conversionRate: null, baseCurrency: null };
        }
      })(L.shopDomain, L.token, M);
      r2.conversionRate && (e2 = { conversion_rate: r2.conversionRate, base_currency: r2.baseCurrency, market_handle: G, market_currency: H });
      window.marketConversionRate = e2, e2 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { market_conversion_rate: JSON.stringify(e2) } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
    }(), function() {
      window.addEventListener("popstate", V);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), V();
      };
      const r2 = history.replaceState;
      history.replaceState = function() {
        r2.apply(this, arguments), V();
      }, V();
    }();
  }();
}();
